import React, { useEffect } from 'react';
import { Breadcrumb, Tabs } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { push } from 'connected-react-router';
import { useParams } from 'react-router-dom';
import { getvaluesfromURL } from '../../helper/Filter';
import '../../assets/scss/components/HostDashboard/index.scss';


const { TabPane } = Tabs;

const SpaceManagementLayout = ({ children, activeTab }) => {
  const dispatch = useDispatch();
  const searchURLstring = (window.location.search);
  const { country, status: paramStatus, spaceId: paramSpaceId } = useParams();
  
  const queryParams = getvaluesfromURL(searchURLstring);
  
  const spaceId = paramSpaceId || queryParams.spaceId;
  const status = paramStatus || queryParams.status || 'ALL';

  const spaceDetails = useSelector((state) => state?.hostDashboard?.data?.spaceDetails || {});
  const fetching = useSelector((state) => state?.hostDashboard?.fetching);
  const isActive = spaceDetails?.spaceStatus === 'ACTIVE';
  
  let isRequestToBook = false;
  if (spaceDetails && 'instanceBookingAvailability' in spaceDetails) {
     isRequestToBook = !spaceDetails.instanceBookingAvailability;
  } else if (spaceDetails?.bookingType === 'REQUEST' || spaceDetails?.bookingType === 'REQUEST_TO_BOOK') {
     isRequestToBook = true;
  }

  useEffect(() => {
    if (fetching || !spaceDetails?.id) return;
  }, [fetching, spaceDetails?.id, isActive, isRequestToBook, activeTab, country, spaceId, status, dispatch]);

  const handleBack = () => {
    const URLtoPush = `/${country}/dashboard/myspaces/${status}`;
    dispatch(push(URLtoPush));
  };

  const handleTabChange = (key) => {
    if (key === '1') {
       // Space Details
       if(activeTab !== '1') {
          const URLtoPush = `/${country}/dashboard/myspaces/${status}/${spaceId}`;
          dispatch(push(URLtoPush));
       }
    } else if (key === '2') {
       // Manage Space (Calendar)
       if (!isActive) return;

       if(activeTab !== '2') {
          const URLtoPush = `/${country}/dashboard/calendar?spaceId=${spaceId}&status=${status}`;
          dispatch(push(URLtoPush));
       }
    }
  };

  const tab2Title = "Manage Space";

  return (
    <div className="space-management-layout">
        <div className="breadcrumb-container">
            <Breadcrumb separator="/">
              <Breadcrumb.Item>
                <span onClick={handleBack} className="cursor-pointer">Spaces List</span>
              </Breadcrumb.Item>
              {activeTab === '2' ? (
                 <Breadcrumb.Item>
                    <span onClick={() => handleTabChange('1')} className="cursor-pointer">Space Details</span>
                 </Breadcrumb.Item>
              ) : null}
              <Breadcrumb.Item>{activeTab === '2' ? tab2Title : 'Space Details'}</Breadcrumb.Item>
            </Breadcrumb>
        </div>

        <div className="tabs-container">
          <Tabs defaultActiveKey={activeTab} type="card" className="host-tabs" onChange={handleTabChange}>
            <TabPane tab="Space Details" key="1" />
            <TabPane tab={tab2Title} key="2" disabled={!isActive} />
          </Tabs>
        </div>
        
        {children}
    </div>
  );
};

export default SpaceManagementLayout;
